<template>
  <!-- eslint-disable -->
	<v-container fluid>
		<v-slide-y-transition mode="out-in">
			<div>
        <h2 style="padding-bottom: 25px;">Queue Management</h2>
				<v-speed-dial v-model="fab" right top fixed direction="bottom" transition="slide-y-reverse-transition" >
          <template v-slot:activator>
            <v-btn class="refresh-btn" v-model="fab" color="blue darken-2" dark fab>
              <v-icon v-if="fab">close</v-icon>
              <v-icon v-else>account_circle</v-icon>
            </v-btn>
          </template>
					<v-btn fab dark small color="red" class="refresh-fixed-cost-btn" @click="load()">
						<v-icon>refresh</v-icon>
					</v-btn>
				</v-speed-dial>
        <v-dialog v-model="postponeDialog" max-width="500px">
					<v-card>
						<v-form ref="form" lazy-validation>
							<v-card-title>
								<span class="headline">Postpone</span>
							</v-card-title>
							<v-card-text style="padding-top: 0;">
								<v-container grid-list-md style="padding-top: 0;">
                  <v-layout>
                    <div style="padding-top: 5px;">Postponing {{getTotalQueueItems(postponedItems)}} tasks for </div>
                    <v-text-field hide-details :max="6 * 60" style="padding: 0 5px 0 5px; margin-top: 0; max-width: 80px;" v-model="postponeTime" type="number"></v-text-field>
                    <div  style="padding-top: 5px;"> Minutes <span v-if="postponeTime > 60">({{(postponeTime/60).toFixed(2)}} hours)</span></div>
                  </v-layout>
								</v-container>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-1" class="cancel-add-btn" text @click="postponeDialog = false;">Cancel</v-btn>
								<v-btn color="blue darken-1" :disabled="!postponeTime" class="save-btn" text @click="postponeQueues(postponedItems)">Postpone</v-btn>
							</v-card-actions>
						</v-form>
					</v-card>
				</v-dialog>
        <v-dialog v-model="queueDetailDialog">
					<v-card>
						<v-form ref="form" lazy-validation>
							<v-card-title>
								<span class="headline">Postpone</span>
							</v-card-title>
							<v-card-text style="padding-top: 0;">
								<v-container grid-list-md style="padding: 0 !important;">
                  <v-data-table :mobile-breakpoint="0" v-show="currentTab === 0" disable-pagination hide-default-footer :items="queueDetailList" item-key="Queue"	:headers="queueDetailListHeaders" :loading="loadingQueueDetailList" :sort-by.sync="queueDetailListSortBy" :sort-desc.sync="queueDetailListDescending" >
                    <template v-slot:item="{ item }" item-key="HashKey">
                      <tr>
                        <td>{{item.Problem}}</td>
                        <td>{{item.Who}}</td>
                        <td>{{item.What}}</td>
                        <td>{{item.RootCauseCode}}</td>
                        <td>{{item.TimeZone}}</td>
                        <td>{{item.Count}}</td>
                        <td>{{clientNames[item.ClientId]}}</td>
                        <td>{{carrierNames[item.CarrierId]}}</td>
                        <td style="text-align: center;">
                          <v-checkbox style="text-align: center; margin-top: 0; padding-top: 0;" v-model="item.Selected" hide-details/>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      <div v-if="loadingQueueList" class="text-xs-center">Loading queue data. . .</div>
                      <div v-else class="text-xs-center">No queue data</div>
                    </template>
                  </v-data-table>
                  <div style="padding-top: 10px;">
                    <v-btn depressed small @click="postpone(true)">Postpone All</v-btn>
                    <v-btn depressed small @click="postpone(false)" style="float: right;">Postpone Selected</v-btn>
                  </div>
								</v-container>
							</v-card-text>
						</v-form>
					</v-card>
				</v-dialog>
        <v-tabs v-model="currentTab" :touchless="true" slider-color="black" >
          <v-tab>Queue</v-tab>
          <v-tab>History</v-tab>
        </v-tabs>
				<v-data-table :mobile-breakpoint="0" v-show="currentTab === 0" disable-pagination hide-default-footer :items="queueList" item-key="Queue"	:headers="queueListHeaders" :loading="loadingQueueList" :sort-by.sync="queueListSortBy" :sort-desc.sync="queueListDescending" >
					<template v-slot:item="{ item }" item-key="HashKey">
						<tr>
							<td>{{item.Problem}}</td>
              <td>{{item.Who}}</td>
							<td>{{item.What}}</td>
              <td>{{item.RootCauseCode}}</td>
              <td>{{item.TimeZone}}</td>
              <td>{{item.Count}}</td>
							<td>
								<v-btn small depressed @click="loadQueueDetails(item.Problem)">Postpone</v-btn>
							</td>
						</tr>
					</template>
					<template slot="no-data">
						<div v-if="loadingQueueList" class="text-xs-center">Loading queue data. . .</div>
						<div v-else class="text-xs-center">No queue data</div>
					</template>
				</v-data-table>
        <div  v-show="currentTab === 1" style="background-color: white;">
          <v-layout row style="padding: 0 25px">
            <v-select :items="historyHoursPastList" item-text="Label" item-value="Hours" v-model="hoursPast"></v-select>
            <v-btn depressed small style="position: relative; top: 10px;" @click="loadHistory(hoursPast)">Go</v-btn>
          </v-layout>
          <v-data-table :mobile-breakpoint="0" class="fixed-costs-data-table" disable-pagination hide-default-footer :items="postponeHistory" item-key="Id"	:headers="historyHeaders" :loading="loadingHistory" :sort-by.sync="historySortBy" :sort-desc.sync="historyDescending" >
            <template v-slot:item="{ item }" item-key="HashKey">
              <tr>
                <td>{{item.Name}}</td>
                <td>{{getTimeAgo(item.Timestamp)}}</td>
                <td>{{item.Action}}</td>
              </tr>
            </template>
            <template slot="no-data">
              <div v-if="loadingHistory" class="text-xs-center">Loading data. . .</div>
              <div v-else class="text-xs-center">No data entered</div>
            </template>
          </v-data-table>
        </div>
			</div>
		</v-slide-y-transition>
	</v-container>
<!-- eslint-enable -->
</template>

<script>
import queueConfigModule, { QUEUE_NAMESPACE } from "./store/queueStore";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "QueueManagement",
  data() {
    return {
      currentTab: 0,
      fab: false,
      historyHoursPastList: [
        {
          Label: "Last 5 Hours",
          Hours: 5
        },
        {
          Label: "Last Day",
          Hours: 24
        },
        {
          Label: "Last Week",
          Hours: 24 * 7
        }
      ],
      hoursPast: 5,
      postponeAll: false,
      postponeDialog: false,
      postponedItems: [],
      postponeTime: 30,
      queueDetailDialog: false,
      queueDetailListHeaders: [
        {
          text: "Workflow",
          sortable: true,
          align: "left",
          value: "Queue"
        },
        {
          text: "Who",
          sortable: true,
          align: "left",
          value: "Who"
        },
        {
          text: "What",
          sortable: true,
          align: "left",
          value: "What"
        },
        {
          text: "Root Cause Code",
          sortable: true,
          align: "left",
          value: "RootCauseCode"
        },
        {
          text: "Timezone",
          sortable: true,
          align: "left",
          value: "TimeZone"
        },
        {
          text: "Count",
          sortable: true,
          align: "left",
          value: "Count"
        },
        {
          text: "Client",
          sortable: true,
          align: "left",
          value: "Client"
        },
        {
          text: "Carrier",
          sortable: true,
          align: "left",
          value: "Carrier"
        },
        {
          text: "Action",
          sortable: false,
          align: "left",
          value: "Action"
        }
      ],
      queueDetailListSortBy: "Count",
      queueDetailListDescending: true,
      queueListHeaders: [
        {
          text: "Workflow",
          sortable: true,
          align: "left",
          value: "Queue"
        },
        {
          text: "Who",
          sortable: true,
          align: "left",
          value: "Who"
        },
        {
          text: "What",
          sortable: true,
          align: "left",
          value: "What"
        },
        {
          text: "Root Cause Code",
          sortable: true,
          align: "left",
          value: "RootCauseCode"
        },
        {
          text: "Timezone",
          sortable: true,
          align: "left",
          value: "TimeZone"
        },
        {
          text: "Count",
          sortable: true,
          align: "left",
          value: "Count"
        },
        {
          text: "Action",
          sortable: false,
          align: "left",
          value: "Action"
        }
      ],
      queueListSortBy: "Count",
      queueListDescending: true,
      historyHeaders: [
        {
          text: "Name",
          sortable: true,
          align: "left",
          value: "Name"
        },
        {
          text: "Postpone Date",
          sortable: true,
          align: "left",
          value: "Timestamp"
        },
        {
          text: "Action",
          sortable: true,
          align: "left",
          value: "Action"
        }
      ],
      historySortBy: "Timestamp",
      historyDescending: true
    };
  },
  computed: {
    ...mapGetters(QUEUE_NAMESPACE, [
      "carrierNames",
      "clientNames",
      "loadingCarriers",
      "loadingClients",
      "loadingHistory",
      "loadingQueueDetailList",
      "loadingQueueList",
      "postponeHistory",
      "queueDetailList",
      "queueList"
    ])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(QUEUE_NAMESPACE, queueConfigModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.QUEUE_ADMIN]).then(
      res => {
        if (res) this.load();
        else this.$goHome();
      }
    );
  },
  methods: {
    getTimeAgo(commitTime) {
      var diff = (moment().diff(moment(commitTime)) / (1000 * 60)).toFixed(0);
      if (diff < 60) return `${diff} min ago`;
      else if (diff < 60 * 24)
        return `${parseInt(diff / 60)} hour${
          parseInt(diff / 60) === 1 ? "" : "s"
        } ago`;
      else return moment(commitTime).format("YYYY-MM-DD HH:MM");
    },
    getTotalQueueItems(postponedItems) {
      var total = 0;
      postponedItems.forEach(x => {
        total += x.Count;
      });
      return total;
    },
    load() {
      this.loadQueues();
      this.loadClients();
      this.loadCarriers();
    },
    loadCarriers() {
      return this.$store.dispatch(`${QUEUE_NAMESPACE}/loadCarriers`);
    },
    loadClients() {
      return this.$store.dispatch(`${QUEUE_NAMESPACE}/loadClients`);
    },
    loadHistory(hoursBack) {
      return this.$store.dispatch(`${QUEUE_NAMESPACE}/loadHistory`, hoursBack);
    },
    loadQueueDetails(workflow) {
      return this.$store
        .dispatch(`${QUEUE_NAMESPACE}/loadQueueDetails`, workflow)
        .then(() => {
          this.queueDetailDialog = true;
        });
    },
    loadQueues() {
      return this.$store.dispatch(`${QUEUE_NAMESPACE}/loadQueues`);
    },
    postpone(postponeAll = false) {
      this.postponedItems = [];
      this.queueDetailList.forEach(x => {
        if (x.Selected || postponeAll)
          this.postponedItems.push({
            CarrierId: x.CarrierId,
            ClientId: x.ClientId,
            TaskType: x.Problem,
            Who: x.Who,
            Count: x.Count
          });
      });
      this.postponeAll = postponeAll;
      this.postponeDialog = true;
    },
    postponeQueues(postponedItems) {
      if (postponedItems.length > 0) {
        var actionText = "";
        var total = this.getTotalQueueItems(postponedItems);
        if (this.postponeAll) {
          actionText = `Postpone all (${total}) ${postponedItems[0].TaskType} tasks for ${this.postponeTime} minutes.`;
        } else {
          actionText = `Postpone ${total} ${postponedItems[0].TaskType} tasks for ${this.postponeTime} minutes.`;
        }
        var postponeData = {
          PostponeTime: this.postponeTime,
          PostponeItems: postponedItems,
          PostponeAll: this.postponeAll,
          ActionText: actionText
        };
        return this.$store
          .dispatch(`${QUEUE_NAMESPACE}/postponeQueues`, postponeData)
          .then(() => {
            this.queueDetailDialog = false;
            this.postponeDialog = false;
            this.loadQueues();
          });
      } else {
        this.queueDetailDialog = false;
        this.postponeDialog = false;
      }
    }
  }
};
</script>
